/** `intentLedger` namespace (ADR 0136) — the mission-contract modal. */
export const messages = {
  button: 'Mission',
  title: 'Mission contract',
  lede: 'A reviewable contract for what the agent may do in this conversation. Approving it narrows the agent’s tools to the contract until you revoke it.',
  createHeading: 'Draft a mission',
  goal: 'Goal',
  goalPlaceholder: 'Goal (what should the agent accomplish?)',
  criteria: 'Success criteria',
  criteriaPlaceholder: 'Success criteria, one per line (optional)',
  createDraft: 'Create draft',
  needGoal: 'Enter a goal.',
  approve: 'Approve',
  reject: 'Reject',
  revoke: 'Revoke mission',
  revokeConfirm: 'Revoke this mission?',
  approved: 'Mission approved',
  rejected: 'Mission rejected',
  expired: 'The previous mission expired — draft a new one.',
  allowed: 'allowed',
  forbidden: 'forbidden',
  needsApproval: 'needs approval',
  reckoning: 'Progress',
  inMandate: 'in mandate',
  outOfMandate: 'blocked attempts',
  used: 'used',
  blocked: 'blocked',
  needsReview: 'needs review',
  status_draft: 'draft',
  status_approved: 'approved',
  status_expired: 'expired',
  status_rejected: 'rejected',
  draftWithAssistant: 'Draft with the assistant',
  draftWithAssistantSeed: 'Draft a mission contract for this conversation — I will review and approve it before it takes effect.',
  loadFailed: 'Failed to load the mission contract.',
  draftFailed: 'Failed to draft the mission.',
  decideFailed: 'Failed to record your decision.',
  inheritedRegion: 'From the team ledger',
  inheritedFrom: 'From the team ledger of {{project}}',
  inScope: 'in scope',
  outOfScope: 'out of scope',
  inheritedNote: 'The mission keeps these restrictions. You can add to them, not remove them.',
  prefillFailed: 'Could not load the team ledger’s defaults. Any restrictions it sets still apply.',
  readOnly: 'Only the conversation’s owner can draft its mission.',
  changedSinceViewed: 'This mission changed since you opened it. Review the version below before you decide.',
  noAllowedTools: 'No tools are listed as allowed — while this mission is approved, the agent can talk but not act.',
  expiresAfter: 'Ends {{duration}} after the agent starts working under it.',
  notDecider: 'Only the conversation’s owner — or a workspace admin, if it has no owner — can approve or revoke this mission.',
  notFound: 'This conversation has no mission yet. Send a message first, then set one.',
  revoked: 'Mission revoked',
  revokeConfirmBody: 'The agent gets back the tools this mission restricted. You can draft a new mission afterwards.',
  changedNowStatus: 'This mission changed since you opened it — it is now {{status}}.',
  ledeViewer: 'A reviewable contract for what the agent may do in this conversation. While approved, it narrows the agent’s tools to the contract.',
  formNoTools: 'A mission drafted here lists no allowed tools, so approving it stops the agent from acting. To let it act within limits, ask the assistant to draft it.',
};
